import { useMutation } from '@tanstack/react-query'
import { demoApi } from '../lib/api'
import type { SimulateCampaignRequest, SimulationResetResult } from '../types/demo'
import type { JobEnqueuedDto } from '../types/job'

// Enqueues the simulation job (202 + jobId); the caller polls useJobPolling(jobId) and invalidates
// campaign data once the job reaches Succeeded.
export function useSimulateCampaign(campaignId: string) {
  return useMutation<JobEnqueuedDto, unknown, SimulateCampaignRequest>({
    mutationFn: (req) => demoApi.simulate(campaignId, req).then((r) => r.data),
  })
}

export function useResetSimulation(campaignId: string) {
  return useMutation<SimulationResetResult, unknown, void>({
    mutationFn: () => demoApi.reset(campaignId).then((r) => r.data),
  })
}
